<template>
  <div v-if="$tools.isDefined(data)">
    <slot/>
  </div>
  <div v-else>
    <v-progress-linear indeterminate rounded/>
  </div>
</template>

<script>
export default {
  props: ['data']
}
</script>
